import { isValidPhoneNumber } from "react-phone-number-input";

export interface PhoneValidationResult {
  valid: boolean;
  error?: string;
}

/**
 * Validates a phone number using react-phone-number-input's isValidPhoneNumber
 * @param phone - The phone number to validate (E.164 format from PhoneInput)
 * @returns Validation result with error message if invalid
 */
export function validatePhone(phone: string): PhoneValidationResult {
  if (!phone || phone.trim() === "") {
    return {
      valid: false,
      error: "Please enter your phone number.",
    };
  }

  if (!isValidPhoneNumber(phone)) {
    return {
      valid: false,
      error: "Please enter a valid phone number.",
    };
  }

  return { valid: true };
}
